import CryptoIcon from "../CryptoIcon";
import "./style.scss";
import TwitterIcon from "assets/icons/twitter.svg";
import {ReactComponent as ArrowRight} from "assets/icons/arrowRight.svg";
import ChangeIndicator from "../ChangeIndicator";
import { formatNumber } from "helpers/helpers";
import {Link} from "react-router-dom";

const mock = [
  {
    name: "Bitcoin",
    symbol:"BTC",
    price: 41503.43,
    marketAddress: "wefwfwef",
    change: {
      percentage: 3.20,
      change: 1040.31
    },
    link: false
  },
  {
    name: "Join the Community",
    symbol:"Check out our Twitter",
    link: "BTC-USD ADDRESS",
    imageURL: TwitterIcon,
    link: true,
    url: "https://google.com"
  },
  {
    name: "Prism",
    symbol:"PRISM",
    price: 0.0931,
    marketAddress: "wefwfwef",
    change: {
      percentage: 5.11,
      change: 1040.31
    },
    link: false
  },
  {
    name: "Solana",
    symbol:"SOL",
    price: 102.32,
    marketAddress: "wefwfwef",
    change: {
      percentage: 7.53,
      change: 1040.31
    },
    link: false
  },
]
const MarketsPromoBar = ({}) => {

  return <div className="marketsPromoBar">
    {
      mock.map((item, i) => {
        if(item.link)
        return <a target={"_blank"} href={item.url} className="promoItem" key={i}>
          <div className="side">
            <div className="flex">
              {
                item.imageURL ?
                <img src={item.imageURL} width={30} height={30}/>
                :
                <CryptoIcon symbol={item.symbol} size={36}/>
              }
              <div className="titles">
                <p className="name">{item.name}</p>
                <p className="symbol">{item.symbol}</p>
              </div>
            </div>
          </div>
          <div className="side" style={{alignItems:"flex-end"}}>
              {
                item.link ?
                <ArrowRight stroke="var(--gray900)"/>
                :
                <div className="titles" style={{alignItems:"flex-end"}}>
                  <p className="name">
                    ${
                      formatNumber(item.price,2)
                    }
                  </p>
                  <ChangeIndicator change={item.change} showFull={false}/>
                </div>
              }
            </div>
        </a>

        if(!item.link)
        return <Link to={""} className="promoItem" key={i} >
          <div className="side">
            <div className="flex">
              {
                item.imageURL ?
                <img src={item.imageURL} width={30} height={30}/>
                :
                <CryptoIcon symbol={item.symbol} size={36}/>
              }
              <div className="titles">
                <p className="name">{item.name}</p>
                <p className="symbol">{item.symbol}</p>
              </div>
            </div>
          </div>
          <div className="side" style={{alignItems:"flex-end"}}>
              {
                item.link ?
                <ArrowRight stroke="var(--gray900)"/>
                :
                <div className="titles" style={{alignItems:"flex-end"}}>
                  <p className="name">
                    ${
                      formatNumber(item.price,2)
                    }
                  </p>
                  <ChangeIndicator change={item.change} showFull={false}/>
                </div>
              }
            </div>
        </Link>
      })
    }
  </div>
}

export default MarketsPromoBar;